export const enum PostableMessageKey {
  SSO_REDIRECT_ASSET_PERSISTENCE_CODE = 'SSO_REDIRECT_ASSET_PERSISTENCE_CODE',
  SSO_REDIRECT_ASSET_PERSISTENCE_PAGE = 'SSO_REDIRECT_ASSET_PERSISTENCE_PAGE'
}
